import {
  createStartAction,
  createSuccessAction,
} from '../../../redux-util/async-helpers';
import {
  CREATE_ADOPTION,
  DELETE_ADOPTION,
  GET_ADOPTION,
  LIST_ADOPTIONS,
} from '../../bridge-methods';
import { UPDATE_ADOPTION_NAME } from '../../bridge-method-remap';

export default function adoptionDataReducer(state = {}, action) {
  const newState = { ...state };
  if (action.type === createSuccessAction(LIST_ADOPTIONS).type) {
    action.data.adoptions.forEach(d => {
      newState[d.id] = d;
    });
    return newState;
  } else if (action.type === createSuccessAction(CREATE_ADOPTION).type) {
    newState[action.data.adoption.id] = action.data.adoption;
    return newState;
  } else if (action.type === createStartAction(UPDATE_ADOPTION_NAME).type) {
    const adoptions = action.data[0].adoptions;
    adoptions.forEach(a => {
      newState[a.id] = {
        ...newState[a.id],
        name: a.name,
      };
    });
    return newState;
  } else if (action.type === createSuccessAction(GET_ADOPTION).type) {
    if (action.data.adoption.id) {
      newState[action.data.adoption.id] = action.data.adoption;
      return newState;
    }
  } else if (action.type === createSuccessAction(DELETE_ADOPTION).type) {
    newState[action.args[0].id] = null;
    return newState;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/adoptions/data/reducer.js